(() => {
  if (window.rivalPartEnquiryReady) return;
  window.rivalPartEnquiryReady = true;
  const dialog = document.querySelector('[data-enquiry-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const clean = (value, max = 200) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max);
  const field = key => form.querySelector(`[data-enquiry-${key}]`);
  const pendingKey = 'rival-enquiry-pending';
  let trigger;
  let previousOverflow;
  let snapshot = '';
  const emptyVehicle = field('vehicle-summary')?.textContent;
  function vehicleContext() {
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"]');
    const active = root?.querySelector('[data-rival-active]');
    if (root?.dataset.selected !== 'true' || !active || active.hidden) return { vehicle: '', registration: '', specs: '' };
    const plate = active.querySelector('[data-rival-plate]');
    return {
      vehicle: clean(active.querySelector('[data-rival-active-label]')?.textContent),
      registration: plate && !plate.hidden ? clean(plate.textContent, 16) : '',
      specs: clean(active.querySelector('.rival-vehicle-specs')?.textContent)
    };
  }
  function summary() {
    if (!field('vehicle')) return;
    field('vehicle-summary').textContent = clean(field('vehicle').value) || emptyVehicle;
    field('plate').textContent = clean(field('registration').value, 16).toUpperCase();
    field('plate').hidden = !field('plate').textContent;
  }
  function open() {
    if (dialog.open) return;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    (dialog.querySelector('[data-enquiry-result]') || form.querySelector('input[type="email"]'))?.focus({ preventScroll: true });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-enquiry-start]');
    if (!link) return;
    event.preventDefault();
    trigger = link;
    if (field('vehicle')) {
      const current = vehicleContext();
      const nextSnapshot = JSON.stringify(current);
      if (snapshot !== nextSnapshot) {
        Object.entries(current).forEach(([key, value]) => { field(key).value = value; });
        snapshot = nextSnapshot;
      }
      const category = clean(link.dataset.enquiryCategory);
      field('category').value = category;
      field('category-summary').textContent = category;
      field('page').value = `${location.origin}${location.pathname}`;
      field('filters').value = [...document.querySelectorAll('.rival-active-filters')]
        .filter(node => node.getClientRects().length)
        .map(node => clean(node.innerText, 350)).filter(Boolean).join('; ').slice(0, 350);
      summary();
    }
    open();
  });
  dialog.querySelectorAll('[data-enquiry-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  form.addEventListener('input', event => {
    event.target.setCustomValidity?.('');
    summary();
  });
  form.addEventListener('submit', event => {
    const message = form.querySelector('textarea');
    if (!message) return;
    if (!message.value.trim()) {
      event.preventDefault();
      message.value = '';
      message.reportValidity();
      return;
    }
    field('registration').value = clean(field('registration').value, 16).toUpperCase();
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ path: location.pathname, at: Date.now() })); } catch { }
  });
  const result = dialog.querySelector('[data-enquiry-result]');
  if (result) {
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (pending?.path === location.pathname && Date.now() - pending.at < 30 * 60 * 1000 && Date.now() >= pending.at) {
        sessionStorage.removeItem(pendingKey);
        open();
      }
    } catch { }
  }
})();
